import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import secureLocalStorage from 'react-secure-storage';

const ClockOutConfirm = ({ setModalShown }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 180000); // 3 minutes

    return () => clearTimeout(timer);
  }, []);

  const handleUnderstood = () => {
    secureLocalStorage.setItem('user_clockout_confirmed', 'true');
    setModalShown(false);
    setIsVisible(false);
  };

  const handleClose = () => {
    setModalShown(false);
    setIsVisible(false);
  };

  return (
    <Modal
      show={isVisible}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>Warning</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ color: 'red' }}>
          You are clocking out in your shift time, do you really want to clock out?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleUnderstood}>
          Ok
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ClockOutConfirm;
